import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useCategoryStore } from "@/stores/categoryStore";
import { CategoryForm } from "./CategoryForm";
import { useUpdateCategory } from '@/hooks/useCategories';
import { toast } from "sonner";
import type { CategoryFormData } from "../types";

interface EditCategoryModalProps {
  providerId: number;
  versionId: number;
}

export function EditCategoryModal({ providerId, versionId }: EditCategoryModalProps) {
  const { isEditModalOpen, closeEditModal, selectedCategory } = useCategoryStore();
  const updateCategory = useUpdateCategory();

  const handleSubmit = async (data: CategoryFormData) => {
    if (!selectedCategory) return;

    try {
      await updateCategory.mutateAsync({
        id: selectedCategory.id,
        name: data.name,
        parentId: data.parentId ?? null,
        displayOrder: selectedCategory.display_order,
        providerId,
        versionId,
        price: data.price,
        description: data.description
      });

      toast.success("Category updated successfully");
      closeEditModal();
    } catch (error) {
      console.error('Update error:', error);
      toast.error(error instanceof Error ? error.message : "Failed to update category");
    }
  };

  if (!selectedCategory) return null;

  return (
    <Dialog open={isEditModalOpen} onOpenChange={closeEditModal}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Edit Category</DialogTitle>
        </DialogHeader>
        <CategoryForm
          providerId={providerId}
          versionId={versionId}
          initialData={{
            name: selectedCategory.name,
            parentId: selectedCategory.parent_id,
            displayOrder: selectedCategory.display_order,
            price: selectedCategory.price,
            description: selectedCategory.description ?? ''
          }}
          onSubmit={handleSubmit}
          isSubmitting={updateCategory.isPending}
          onCancel={closeEditModal}
        />
      </DialogContent>
    </Dialog>
  );
} 